import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ButtonWrapper, Label } from './styles';

export default function SurveyOption({ label, name, isSending, sendSelectedOption }) {
  const [selected, setSelected] = useState(null);
  const handleClick = event => {
    if (isSending) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    setSelected(true);
    sendSelectedOption(name);
  };

  return (
    <>
      <ButtonWrapper
        onClick={handleClick}
        key={`button-value-${name}`}
        $selected={selected}
        $disabled={isSending && !selected}
      >
        <Label component="p" variant="DS_labelSmallRegular">
          {label}
        </Label>
      </ButtonWrapper>
    </>
  );
}

SurveyOption.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  selectOption: PropTypes.func,
  selectedOption: PropTypes.string,
  sendSelectedOption: PropTypes.func,
  value: PropTypes.string,
};
